import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllFlow = createAsyncThunk(
  "GetAllFlow/GetAllFlow",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetAllFlow",
        parameters
      );

      const data = response.data.result;
      console.log(data, "app");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AllFlow = createSlice({
  name: "AllFlow",
  initialState: {
    AllFlow: [],
    loadingAllFlow: false,
    errorAllFlow: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllFlow.pending, (state, action) => {
        state.loadingAllFlow = true;
        state.AllFlow = action.payload;
        state.errorAllFlow = null;
      })
      .addCase(GetAllFlow.fulfilled, (state, action) => {
        state.loadingAllFlow = false;
        state.AllFlow = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllFlow.rejected, (state, action) => {
        state.loadingAllFlow = false;
        state.errorAllFlow = action.payload;
      });
  },
});

export default AllFlow.reducer;
